import _classCallCheck from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/joeloliveira/Development/WWW/Projects/notificare-docs/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { logInternal, getCurrentDevice, NotificareNetworkRequestError, NotificareDeviceUnavailableError, getCloudApiEnvironment, isReady, Component, getOptions, registerComponent } from '@notificare/web-core';
import { fetchCloudInAppMessage } from '@notificare/web-cloud-api';
import { Logger } from '@notificare/web-logger';
import { createRoot, createBackdrop, createCloseButton, createButton } from '@notificare/web-ui';
var logger = new Logger('notificare/in-app-messaging');

function convertCloudInAppMessageToPublic(message) {
  var _a, _b;

  return {
    // eslint-disable-next-line no-underscore-dangle
    id: message._id,
    name: message.name,
    type: message.type,
    context: (_a = message.context) !== null && _a !== void 0 ? _a : [],
    title: message.title,
    message: message.message,
    image: message.image,
    landscapeImage: message.landscapeImage,
    delaySeconds: (_b = message.delaySeconds) !== null && _b !== void 0 ? _b : 0,
    primaryAction: convertCloudInAppMessageActionToPublic(message.primaryAction),
    secondaryAction: convertCloudInAppMessageActionToPublic(message.secondaryAction)
  };
}

function convertCloudInAppMessageActionToPublic(action) {
  var _a;

  if (!action) return undefined;
  return {
    label: action.label,
    destructive: (_a = action.destructive) !== null && _a !== void 0 ? _a : false,
    url: action.url
  };
}

var messagePresentedCallback;
var messageFinishedPresentingCallback;
var messageFailedToPresentCallback;
var actionExecutedCallback;
var actionFailedToExecuteCallback;

function onMessagePresented(callback) {
  messagePresentedCallback = callback;
  return {
    remove: function remove() {
      messagePresentedCallback = undefined;
    }
  };
}

function onMessageFinishedPresenting(callback) {
  messageFinishedPresentingCallback = callback;
  return {
    remove: function remove() {
      messageFinishedPresentingCallback = undefined;
    }
  };
}

function onMessageFailedToPresent(callback) {
  messageFailedToPresentCallback = callback;
  return {
    remove: function remove() {
      messageFailedToPresentCallback = undefined;
    }
  };
}

function onActionExecuted(callback) {
  actionExecutedCallback = callback;
  return {
    remove: function remove() {
      actionExecutedCallback = undefined;
    }
  };
}

function onActionFailedToExecute(callback) {
  actionFailedToExecuteCallback = callback;
  return {
    remove: function remove() {
      actionFailedToExecuteCallback = undefined;
    }
  };
}

function notifyMessagePresented(message) {
  var callback = messagePresentedCallback;

  if (!callback) {
    logger.debug("The 'message_presented' handler is not configured.");
    return;
  }

  callback(message);
}

function notifyMessageFinishedPresenting(message) {
  var callback = messageFinishedPresentingCallback;

  if (!callback) {
    logger.debug("The 'message_finished_presenting' handler is not configured.");
    return;
  }

  callback(message);
}

function notifyMessageFailedToPresent(message) {
  var callback = messageFailedToPresentCallback;

  if (!callback) {
    logger.debug("The 'message_failed_to_present' handler is not configured.");
    return;
  }

  callback(message);
}

function notifyActionExecuted(message, action) {
  var callback = actionExecutedCallback;

  if (!callback) {
    logger.debug("The 'action_executed' handler is not configured.");
    return;
  }

  callback(message, action);
}

function notifyActionFailedToExecute(message, action) {
  var callback = actionFailedToExecuteCallback;

  if (!callback) {
    logger.debug("The 'action_failed_to_execute' handler is not configured.");
    return;
  }

  callback(message, action);
}

function logInAppMessageViewed(_x) {
  return _logInAppMessageViewed.apply(this, arguments);
}

function _logInAppMessageViewed() {
  _logInAppMessageViewed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(message) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return logInternal({
              type: 're.notifica.event.inappmessage.View',
              data: {
                message: message.id
              }
            });

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _logInAppMessageViewed.apply(this, arguments);
}

function logInAppMessageActionClicked(_x2, _x3) {
  return _logInAppMessageActionClicked.apply(this, arguments);
}

function _logInAppMessageActionClicked() {
  _logInAppMessageActionClicked = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(message, actionType) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return logInternal({
              type: 're.notifica.event.inappmessage.Action',
              data: {
                message: message.id,
                action: actionType
              }
            });

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _logInAppMessageActionClicked.apply(this, arguments);
}

var ApplicationState;

(function (ApplicationState) {
  ApplicationState[ApplicationState["FOREGROUND"] = 0] = "FOREGROUND";
  ApplicationState[ApplicationState["BACKGROUND"] = 1] = "BACKGROUND";
})(ApplicationState || (ApplicationState = {}));

var ActionType;

(function (ActionType) {
  ActionType["PRIMARY"] = "primary";
  ActionType["SECONDARY"] = "secondary";
})(ActionType || (ActionType = {}));

var MessageType;

(function (MessageType) {
  MessageType["BANNER"] = "re.notifica.inappmessage.Banner";
  MessageType["CARD"] = "re.notifica.inappmessage.Card";
  MessageType["FULLSCREEN"] = "re.notifica.inappmessage.Fullscreen";
})(MessageType || (MessageType = {}));

var ROOT_ELEMENT_IDENTIFIER = 'notificare-in-app-messaging';

function ensureCleanState() {
  var root = document.getElementById(ROOT_ELEMENT_IDENTIFIER);
  if (root) root.remove();
}

function createBannerComponent(params) {
  var dismiss = params.dismiss;
  var root = createRoot(ROOT_ELEMENT_IDENTIFIER);
  root.appendChild(createBackdrop(function () {
    return dismiss();
  }));
  root.appendChild(createBannerElement(params));
  return root;
}

function createBannerElement(_ref) {
  var message = _ref.message,
      executeAction = _ref.executeAction;
  var container = document.createElement('div');
  container.classList.add('notificare__iam-banner');
  container.addEventListener('click', function (e) {
    // Prevent the backdrop from receiving events when content is clicked.
    e.preventDefault(); // Execute the primary action.

    executeAction(ActionType.PRIMARY);
  });

  if (message.image) {
    var element = container.appendChild(document.createElement('img'));
    element.classList.add('notificare__iam-banner-image');
    element.setAttribute('src', message.image);
  }

  var content = container.appendChild(document.createElement('div'));
  content.classList.add('notificare__iam-banner-content');

  if (message.title) {
    var _element = content.appendChild(document.createElement('p'));

    _element.classList.add('notificare__iam-banner-content-title');

    _element.innerHTML = message.title;
  }

  if (message.message) {
    var _element2 = content.appendChild(document.createElement('p'));

    _element2.classList.add('notificare__iam-banner-content-message');

    _element2.innerHTML = message.message;
  }

  return container;
}

function createCardComponent(_ref2) {
  var message = _ref2.message,
      dismiss = _ref2.dismiss,
      executeAction = _ref2.executeAction;
  var root = createRoot(ROOT_ELEMENT_IDENTIFIER);
  root.appendChild(createBackdrop(function () {
    return dismiss();
  }));
  root.appendChild(createCardElement(message, function () {
    return dismiss();
  }, function (type) {
    return executeAction(type);
  }));
  return root;
}

function createCardElement(message, onCloseButtonClick, onActionClick) {
  var container = document.createElement('div');
  container.classList.add('notificare__iam-card');
  container.addEventListener('click', function (e) {
    // Prevent the backdrop from receiving events when content is clicked.
    e.preventDefault();
  });
  container.appendChild(createHeaderElement(message, function () {
    return onCloseButtonClick();
  }));
  container.appendChild(createContentElement(message));
  var actionsElement = createActionsElement(message, onActionClick);
  if (actionsElement) container.appendChild(actionsElement);
  return container;
}

function createHeaderElement(message, dismiss) {
  var header = document.createElement('div');
  header.classList.add('notificare__iam-card-header');

  if (message.image) {
    var element = header.appendChild(document.createElement('img'));
    element.classList.add('notificare__iam-card-header-image');
    element.setAttribute('src', message.image);
  }

  header.appendChild(createCloseButton({
    variant: message.image ? 'solid' : 'default',
    onClick: function onClick() {
      return dismiss();
    }
  }));
  return header;
}

function createContentElement(message) {
  var content = document.createElement('div');
  content.classList.add('notificare__iam-card-content');

  if (message.title) {
    var element = content.appendChild(document.createElement('p'));
    element.classList.add('notificare__iam-card-content-title');
    element.innerHTML = message.title;
  }

  if (message.message) {
    var _element3 = content.appendChild(document.createElement('p'));

    _element3.classList.add('notificare__iam-card-content-message');

    _element3.innerHTML = message.message;
  }

  return content;
}

function createActionsElement(message, onActionClick) {
  var primaryActionButton = createActionButton({
    action: message.primaryAction,
    actionType: ActionType.PRIMARY,
    onClick: function onClick() {
      return onActionClick(ActionType.PRIMARY);
    }
  });
  var secondaryActionButton = createActionButton({
    action: message.secondaryAction,
    actionType: ActionType.SECONDARY,
    onClick: function onClick() {
      return onActionClick(ActionType.SECONDARY);
    }
  });
  if (!primaryActionButton && !secondaryActionButton) return undefined;
  var container = document.createElement('div');
  container.classList.add('notificare__iam-card-actions');
  if (primaryActionButton) container.appendChild(primaryActionButton);
  if (secondaryActionButton) container.appendChild(secondaryActionButton);
  return container;
}

function createActionButton(_ref3) {
  var action = _ref3.action,
      actionType = _ref3.actionType,
      onClick = _ref3.onClick;
  if (!(action === null || action === void 0 ? void 0 : action.label) || !(action === null || action === void 0 ? void 0 : action.url)) return undefined;
  var button = createButton({
    variant: action.destructive ? 'destructive' : actionType,
    text: action.label,
    onClick: onClick
  });
  button.classList.add('notificare__iam-card-action');
  button.setAttribute('data-action-type', actionType);
  return button;
}

function createFullscreenComponent(_ref4) {
  var message = _ref4.message,
      _dismiss = _ref4.dismiss,
      _executeAction = _ref4.executeAction;
  var root = createRoot(ROOT_ELEMENT_IDENTIFIER);

  var onWindowResize = function onWindowResize() {
    var element = document.getElementsByClassName('notificare__iam-fullscreen-image')[0];
    if (!element) return;
    var newImage = getOrientationConstrainedImage(message);
    if (!newImage || element.getAttribute('src') === newImage) return;
    element.setAttribute('src', newImage);
  };

  root.appendChild(createBackdrop(function () {
    return _dismiss();
  }));
  root.appendChild(createFullscreenElement({
    message: message,
    dismiss: function dismiss() {
      window.removeEventListener('resize', onWindowResize);

      _dismiss();
    },
    executeAction: function executeAction(type) {
      window.removeEventListener('resize', onWindowResize);

      _executeAction(type);
    }
  }));
  window.addEventListener('resize', onWindowResize);
  return root;
}

function createFullscreenElement(_ref5) {
  var message = _ref5.message,
      dismiss = _ref5.dismiss,
      executeAction = _ref5.executeAction;
  var container = document.createElement('div');
  container.classList.add('notificare__iam-fullscreen');
  container.addEventListener('click', function (e) {
    // Click captured by the close button.
    if (e.defaultPrevented) return; // Prevent the backdrop from receiving events when content is clicked.

    e.preventDefault(); // Execute the primary action.

    executeAction(ActionType.PRIMARY);
  });
  var image = getOrientationConstrainedImage(message);

  if (image) {
    var element = container.appendChild(document.createElement('img'));
    element.classList.add('notificare__iam-fullscreen-image');
    element.setAttribute('src', image);
  }

  container.appendChild(createCloseButton({
    variant: 'solid',
    onClick: function onClick() {
      return dismiss();
    }
  }));

  if (message.title || message.message) {
    var content = container.appendChild(document.createElement('div'));
    content.classList.add('notificare__iam-fullscreen-content');

    if (message.title) {
      var _element4 = content.appendChild(document.createElement('p'));

      _element4.classList.add('notificare__iam-fullscreen-content-title');

      _element4.innerHTML = message.title;
    }

    if (message.message) {
      var _element5 = content.appendChild(document.createElement('p'));

      _element5.classList.add('notificare__iam-fullscreen-content-message');

      _element5.innerHTML = message.message;
    }
  }

  return container;
}

function getOrientationConstrainedImage(message) {
  var _a, _b;

  var isLandscape = window.innerWidth > window.innerHeight;
  if (isLandscape) return (_a = message.landscapeImage) !== null && _a !== void 0 ? _a : message.image;
  return (_b = message.image) !== null && _b !== void 0 ? _b : message.landscapeImage;
}

var shownMessage;

function isShowingMessage() {
  return shownMessage != null;
}

function showMessage(message) {
  shownMessage = message;
  var element;

  switch (message.type) {
    case MessageType.BANNER:
      {
        element = createBannerComponent({
          message: message,
          dismiss: function dismiss() {
            return dismissMessage();
          },
          executeAction: function executeAction(type) {
            return presentAction(message, type);
          }
        });
        break;
      }

    case MessageType.CARD:
      {
        element = createCardComponent({
          message: message,
          dismiss: function dismiss() {
            return dismissMessage();
          },
          executeAction: function executeAction(type) {
            return presentAction(message, type);
          }
        });
        break;
      }

    case MessageType.FULLSCREEN:
      {
        element = createFullscreenComponent({
          message: message,
          dismiss: function dismiss() {
            return dismissMessage();
          },
          executeAction: function executeAction(type) {
            return presentAction(message, type);
          }
        });
        break;
      }

    default:
      throw new Error("Unsupported in-app message type '".concat(message.type, "'."));
  }

  document.body.appendChild(element);
}

function dismissMessage() {
  var currentMessage = shownMessage;

  if (!currentMessage) {
    logger.debug('There is no in-app message to dismiss.');
    return;
  }

  ensureCleanState();
  shownMessage = undefined;
  notifyMessageFinishedPresenting(currentMessage);
}

function presentAction(message, type) {
  var _a;

  var action;

  switch (type) {
    case ActionType.PRIMARY:
      action = message.primaryAction;
      break;

    case ActionType.SECONDARY:
      action = message.secondaryAction;
      break;

    default:
      throw new Error("Unsupported action type '".concat(type, "'."));
  }

  if (!action) {
    logger.debug("There is no '".concat(type, "' action to process."));
    dismissMessage();
    return;
  }

  var url = (_a = action.url) === null || _a === void 0 ? void 0 : _a.trim();

  if (!url) {
    logger.debug("There is no URL for '".concat(type, "' action."));
    dismissMessage();
    return;
  }

  logInAppMessageActionClicked(message, type).then(function () {
    return logger.debug('In-app message action event tracked.');
  }).catch(function (error) {
    return logger.error('Failed to log in-app message action.', error);
  });

  try {
    window.location.href = url;
    notifyActionExecuted(message, action);
  } catch (e) {
    notifyActionFailedToExecute(message, action);
  }

  dismissMessage();
}

var DEFAULT_BACKGROUND_GRACE_PERIOD_MILLIS = 5 * 60 * 1000;
var messagesSuppressed = false;
var applicationState = ApplicationState.BACKGROUND;
var backgroundTimestamp;
var delayedMessageTimeoutId;

function hasMessagesSuppressed() {
  return messagesSuppressed;
}

function setMessagesSuppressed(suppressed, evaluate) {
  var suppressChanged = suppressed !== messagesSuppressed;
  var canEvaluate = !suppressed && suppressChanged && evaluate;
  messagesSuppressed = suppressed;

  if (canEvaluate) {
    evaluateContext('foreground');
  }
}

function evaluateContext(context) {
  logger.debug("Checking in-app message for context '".concat(context, "'."));
  var device = getCurrentDevice();

  if (!device) {
    logger.warning('Cannot process in-app messages before the device is made available.');
    return;
  }

  fetchInAppMessage(context).then(function (message) {
    return processMessage(message);
  }).catch(function (error) {
    if (error instanceof NotificareNetworkRequestError && error.response.status === 404) {
      logger.debug("There is no in-app message for '".concat(context, "' context to process."));

      if (context === 'launch') {
        evaluateContext('foreground');
      }

      return;
    }

    logger.error("Failed to process in-app message for context '".concat(context, "'."), error);
  });
}

function processMessage(message) {
  logger.info("Processing in-app message '".concat(message.name, "'."));

  if (message.delaySeconds > 0) {
    logger.debug("Waiting ".concat(message.delaySeconds, " seconds before presenting the in-app message.")); // Keep a reference to the job to cancel it when the app goes into the background.

    delayedMessageTimeoutId = window.setTimeout(function () {
      presentMessage(message);
    }, message.delaySeconds * 1000);
    return;
  }

  presentMessage(message);
}

function presentMessage(message) {
  if (isShowingMessage()) {
    logger.warning('Cannot display an in-app message while another is being presented.');
    notifyMessageFailedToPresent(message);
    return;
  }

  if (hasMessagesSuppressed()) {
    logger.warning('Cannot display an in-app message while messages are being suppressed.');
    notifyMessageFailedToPresent(message);
    return;
  }

  showMessage(message);
  notifyMessagePresented(message);
  logger.debug('Tracking in-app message viewed event.');
  logInAppMessageViewed(message).catch(function (e) {
    return logger.error('Failed to log in-app message viewed event.', e);
  });
}

function fetchInAppMessage(_x4) {
  return _fetchInAppMessage.apply(this, arguments);
}

function _fetchInAppMessage() {
  _fetchInAppMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context) {
    var device, _yield$fetchCloudInAp, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            device = getCurrentDevice();

            if (device) {
              _context5.next = 3;
              break;
            }

            throw new NotificareDeviceUnavailableError();

          case 3:
            _context5.next = 5;
            return fetchCloudInAppMessage({
              environment: getCloudApiEnvironment(),
              deviceId: device.id,
              context: context
            });

          case 5:
            _yield$fetchCloudInAp = _context5.sent;
            message = _yield$fetchCloudInAp.message;
            return _context5.abrupt("return", convertCloudInAppMessageToPublic(message));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _fetchInAppMessage.apply(this, arguments);
}

function handleDocumentVisibilityChanged(visibilityState) {
  if (visibilityState === 'hidden') {
    applicationState = ApplicationState.BACKGROUND;
    backgroundTimestamp = Date.now();

    if (delayedMessageTimeoutId) {
      logger.info('Clearing delayed in-app message while going to the background.');
      window.clearTimeout(delayedMessageTimeoutId);
      delayedMessageTimeoutId = undefined;
    }

    return;
  } // No need to run the check when we already processed the foreground check.


  if (applicationState === ApplicationState.FOREGROUND) return;

  if (isShowingMessage() && backgroundTimestamp) {
    if (Date.now() > backgroundTimestamp + DEFAULT_BACKGROUND_GRACE_PERIOD_MILLIS) {
      logger.debug('Dismiss the shown in-app message for being in the background for too long.');
      dismissMessage();
    }
  }

  applicationState = ApplicationState.FOREGROUND;
  backgroundTimestamp = undefined;

  if (!isReady()) {
    logger.debug('Postponing in-app message evaluation until Notificare is launched.');
    return;
  }

  if (isShowingMessage()) {
    logger.debug('Skipping context evaluation since there is another in-app message being presented.');
    return;
  }

  if (hasMessagesSuppressed()) {
    logger.debug('Skipping context evaluation since in-app messages are being suppressed.');
    return;
  }

  evaluateContext('foreground');
}
/* eslint-disable class-methods-use-this */


var IamComponent = /*#__PURE__*/function (_Component) {
  _inherits(IamComponent, _Component);

  var _super = _createSuper(IamComponent);

  function IamComponent() {
    _classCallCheck(this, IamComponent);

    return _super.call(this, 'in-app-messaging');
  }

  _createClass(IamComponent, [{
    key: "configure",
    value: function configure() {
      document.addEventListener('visibilitychange', function () {
        var _document = document,
            visibilityState = _document.visibilityState;
        handleDocumentVisibilityChanged(visibilityState);
      });
    }
  }, {
    key: "launch",
    value: function () {
      var _launch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options, device;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = getOptions();
                device = getCurrentDevice();

                if (!((options === null || options === void 0 ? void 0 : options.ignoreTemporaryDevices) && !device)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                evaluateContext('launch');

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function launch() {
        return _launch.apply(this, arguments);
      }

      return launch;
    }()
  }, {
    key: "unlaunch",
    value: function () {
      var _unlaunch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function unlaunch() {
        return _unlaunch.apply(this, arguments);
      }

      return unlaunch;
    }()
  }]);

  return IamComponent;
}(Component);

function registerComponents() {
  registerComponent(new IamComponent());
}

registerComponents();
export { hasMessagesSuppressed, onActionExecuted, onActionFailedToExecute, onMessageFailedToPresent, onMessageFinishedPresenting, onMessagePresented, setMessagesSuppressed };